/**
 * Framework-agnostic mirror of the authenticated user, readable outside React
 * (plain modules like policy.service.js and the Zustand policyStore cannot call
 * the useAuth() hook). AuthContext calls setCurrentUser() alongside every
 * setUser() so this always reflects the same session state — no separate fetch.
 */

let currentUser = null;

export function setCurrentUser(user) {
  currentUser = user || null;
}

export function getCurrentUser() {
  return currentUser;
}

const sharedAuthService = { getCurrentUser, setCurrentUser };

export default sharedAuthService;
